module.exports = "/_next/static/files/0242ffbf4c686c8a8bb38a711827f1da.jpg";